module.exports = __webpack_public_path__ + "static/img/flowchart-scr.cfc12f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowchart-scr.svg?data
// module id = Ccbb
// module chunks = 1